import HeroTip from "/app/src/components/HeroUi/Tip";

/**
 * A wrapper component that conditionally disables its children by applying specific CSS classes.
 *
 * @param {React.ReactNode} children - The child elements to render within the wrapper.
 * @param {boolean} [disabled=false] - Whether to apply disabled styles to the wrapper.
 * @returns {JSX.Element} The rendered wrapper element containing children.
 */
export default function DisabledWrapper({
  children,
  tooltip,
  disabled = false,
}: {
  children: React.ReactNode;
  tooltip?: string;
  disabled?: boolean;
}) {
  const wrapper = (
    <div className={`${disabled ? "cursor-not-allowed" : ""}`}>
      <div className={`${disabled ? "pointer-events-none opacity-50" : ""}`}>
        {children}
      </div>
    </div>
  );

  return tooltip && disabled ? (
    <HeroTip content={tooltip}>{wrapper}</HeroTip>
  ) : (
    wrapper
  );
}
